export var OnboardingCustomRequestType;
(function (OnboardingCustomRequestType) {
    OnboardingCustomRequestType["Text"] = "text";
    OnboardingCustomRequestType["File"] = "file";
    OnboardingCustomRequestType["TextAndFile"] = "text-and-file";
    OnboardingCustomRequestType["SectionTitle"] = "section-title";
})(OnboardingCustomRequestType || (OnboardingCustomRequestType = {}));
//# sourceMappingURL=index.js.map